import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { ArrowLeft, Lock, Check, Circle, Award } from "lucide-react";
import { themeClass } from "../components/ThemeChip";

export default function Themes() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [themes, setThemes] = useState([]);
  const [milestones, setMilestones] = useState([]);

  useEffect(() => {
    (async () => {
      const [p, t, m] = await Promise.all([
        api.get("/curriculum/progress"),
        api.get("/curriculum/themes"),
        api.get("/milestones"),
      ]);
      setData(p.data);
      setThemes(t.data);
      setMilestones(m.data);
    })();
  }, []);

  const milestonesByTheme = milestones.reduce((acc, m) => { acc[m.theme_id] = m; return acc; }, {});

  return (
    <div className="min-h-screen pb-24" data-testid="themes-screen">
      <div className="max-w-md mx-auto px-6 pt-8">
        <div className="flex items-center justify-between mb-6">
          <button onClick={() => nav(-1)} className="p-2 rounded-full hover:bg-white/70" data-testid="themes-back">
            <ArrowLeft className="w-5 h-5"/>
          </button>
          <h1 className="font-display text-2xl">Your journey</h1>
          <div className="w-9"/>
        </div>

        <div className="space-y-6">
          {themes.map((th) => {
            const weeks = (data?.weeks || []).filter((w) => w.theme_slug === th.slug);
            const isPub = th.status === "published";
            return (
              <div key={th.id} className={`card-soft p-5 ${themeClass(th.color_token)}`}
                   data-testid={`theme-card-${th.slug}`}>
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-xs uppercase tracking-widest theme-text">Month {th.month_number || "-"}</div>
                    <h2 className="font-display text-2xl">{th.title}</h2>
                    <p className="text-sm text-muted-foreground">{th.subtitle}</p>
                  </div>
                  {!isPub && <Lock className="w-5 h-5 text-muted-foreground"/>}
                  {milestonesByTheme[th.id] && (
                    <div className="flex items-center gap-1 chip theme-surface theme-text">
                      <Award className="w-3 h-3"/>{milestonesByTheme[th.id].badge_title}
                    </div>
                  )}
                </div>

                {isPub && weeks.length > 0 && (
                  <div className="mt-4 space-y-2">
                    {weeks.map((w) => (
                      <div key={w.week_id} className="flex items-center gap-3 text-sm"
                           data-testid={`theme-week-${w.week_id}`}>
                        {w.state === "completed" && <Check className="w-4 h-4 text-[hsl(var(--neu-orange))]"/>}
                        {w.state === "current" && <Circle className="w-4 h-4 text-[hsl(var(--neu-orange))] fill-current"/>}
                        {w.state === "locked_next_sunday" && <Lock className="w-4 h-4 text-muted-foreground"/>}
                        {w.state === "locked" && <Lock className="w-4 h-4 text-muted-foreground opacity-50"/>}
                        <span className={w.state === "current" ? "font-medium" : ""}>
                          Week {w.week_number}: {w.title}
                        </span>
                        {w.state === "current" && <span className="ml-auto chip theme-accent-bg text-white">Current</span>}
                        {w.state === "locked_next_sunday" && (
                          <span className="ml-auto text-xs text-muted-foreground">
                            Unlocks {w.unlocks_on ? `on ${w.unlocks_on}` : "next Sunday"}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {!isPub && <p className="mt-4 text-sm text-muted-foreground">Coming soon. We're crafting it carefully.</p>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
